<template>
  <div v-if="items.length" class="flex flex-col gap-4">
    <ul class="grid gap-6 md:gap-8 pl-0 list-none">
      <iatl-episode-card
        v-for="episode in items"
        :key="episode.id"
        :playing="episode.id === playing?.id"
        v-bind="{ episode, playlist, theme }"
      />
    </ul>

    <div v-if="!expanded && limit && count > limit">
      <l-button
        class="mt-6 text-left font-medium"
        variant="link"
        @click="expanded = true"
      >
        Show {{ count - limit }} more episodes
      </l-button>
    </div>
  </div>
  <slot v-else name="loading"/>
</template>

<script setup>
import IatlEpisodeCard from "@/components/podcasts/IatlEpisodeCard.vue"
import LButton from "@/components/buttons/LButton.vue"
import { api } from "@/api"
import { computed, onMounted, ref } from "vue"

const props = defineProps({
  episodes: { type: Array, default: () => window.episodes },
  limit: Number,
  playing: Object,
  playlist: Object,
  theme: String,
})

const expanded = ref(false)

const results = ref([])

const count = computed(() => results.value.length)

const items = computed(() => {
  return expanded.value || !props.limit ? results.value : results.value.slice(0, props.limit)
})

onMounted(() => {
  if (props.episodes) {
    results.value = props.episodes
  } else {
    api.podcastEpisodeList({ playlist: props.playlist?.slug }).then(({ data }) => {
      results.value = data
      window.episodes = data
    })
  }
})
</script>
